// extracted by mini-css-extract-plugin
module.exports = {"img":"Avatar_img__3QaOB","initials":"Avatar_initials__2VROM"};